import invalidCircleIcon from 'assets/img/invalidCircle.svg';
import { Heading, Text, Stack } from '@chakra-ui/react';
import { AppShellButton } from 'components/Button/AppShellButton';
import { ContainerOverlay } from 'components/Container/ContainerOverlay';
import { InstructionCallout } from 'components/Instruction/InstructionCallout';
import { ReactNode } from 'react';

const GenericError = ({
  buttonLabel,
  title,
  children,
  onClick,
  isSecondaryButton = false,
  instructionsLink,
}: {
  buttonLabel?: string;
  title: string;
  children: ReactNode;
  isSecondaryButton?: boolean;
  onClick?: () => void;
  instructionsLink?: string;
}) => {
  return (
    <ContainerOverlay>
      <Stack p="6" h="full" justify="space-between">
        <Stack px="6" gap="6" py="40px" align="center">
          <img alt="invalid-circle" src={invalidCircleIcon} />
          <Heading fontWeight="medium">{title}</Heading>
          <Text textAlign="center">{children}</Text>
          {instructionsLink && (
            <InstructionCallout link={instructionsLink} checkPermissions />
          )}
        </Stack>
        {buttonLabel && (
          <Stack align="center">
            <AppShellButton
              variant={isSecondaryButton ? 'outline' : 'solid'}
              onClick={
                onClick
                  ? onClick
                  : () => {
                      window.location.reload();
                    }
              }
            >
              {buttonLabel}
            </AppShellButton>
          </Stack>
        )}
      </Stack>
    </ContainerOverlay>
  );
};

export default GenericError;
